import { render, staticRenderFns } from "./ViewIssue.vue?vue&type=template&id=a43efe82&"
import script from "./ViewIssue.vue?vue&type=script&lang=js&"
export * from "./ViewIssue.vue?vue&type=script&lang=js&"
import style0 from "./ViewIssue.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ViewIssue.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports